import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  TableCaption,
  Thead,
  Tbody,
  Button,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Image,
  Box,
  Flex,
  Text,
  IconButton,
} from "@chakra-ui/react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaEdit, FaTrash, FaFilter, FaTimes } from "react-icons/fa";
import UpdateRoomBookModal from "./updateRoomBookModal";
import toast from "react-hot-toast";
import ForeignReportModal from "./foreignReportModal";
import Cookie from "js-cookie";
import RoomBookPrintModal from "./roomBookPrintModal";

const RoomBookData = () => {
  const [data, setData] = useState([]);
  const token = Cookie.get("token");
  const [filteredData, setFilteredData] = useState([]);
  const [roomBook, setRoomBookData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isForeignReport, setIsForeignReport] = useState(false);
  const [registrationNo, setRegistrationNo] = useState("");
  const [id, setId] = useState("");
  const [isOpen1, setIsOpen] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const cancelRef = useRef();
  const customerId = localStorage.getItem("customerId");

  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();

  const {
    isOpen: isPrintOpen,
    onOpen: onPrintOpen,
    onClose: onPrintClose,
  } = useDisclosure();

  // Fetch all data on initial load
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getRoomBookData/${customerId}`,
      );
      setData(response.data.room);
      setFilteredData(response.data.room);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
    } finally {
      setIsLoading(false);
    }
  };

  const edit = async (id, registration, isForeign = false) => {
    try {
      const response = await axios.get(
        `https://api.hotel.launchlysoftware.in/api/getRoomBookDataById/${customerId}/${id}`,
      );
      setRoomBookData(response.data.room);
      setId(id);
      setRegistrationNo(registration);
      setIsForeignReport(isForeign);
      onEditOpen();
    } catch (error) {
      toast.error("Failed to fetch Cash data");
    }
  };

  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `https://api.hotel.launchlysoftware.in/api/deleteRoomBook/${customerId}/${deleteItemId}?customerId=${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      toast.success("Data deleted successfully");
      onClose1();
      fetchData();
    } catch (error) {
      console.error("Error deleting data:", error);
      toast.error(error.response?.data?.message || "Failed to delete data");
    }
  };

  const DeleteModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose1 = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };

  // Function to handle search input change
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Handle date changes
  const handleStartChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndChange = (e) => {
    setEndDate(e.target.value);
  };

  // Clear date filters
  const clearDateFilter = () => {
    setStartDate("");
    setEndDate("");
  };

  // Clear all filters
  const clearAllFilters = () => {
    setSearchTerm("");
    clearDateFilter();
  };

  const handlePrintModal = () => {
    onPrintOpen();
  };

  const exportToExcel = () => {
    const dataToExport = filteredData.map((item) => ({
      Name: item.name,
      Email: item.email,
      Nationality: item.nationality,
      Purpose: item.purpose,
      Registration: item.registration,
      Pax: item.pax,
      Adult: item.adult,
      Child: item.child,
      Date: item.date,
      ArrivedFrom: item.arrivedFrom,
      NextDestination: item.nextDestination,
      Address: item.address,
      GstNo: item.gstNo,
      PhoneNo: item.phoneNo,
      Adhar: item.adhar,
      VoterId: item.voterId,
      Passport: item.passport,
      GovernmentIssuedId: item.goverMentIssuedId,
      CheckIn: item.checkIn,
      CheckOut: item.checkOut,
      RoomNo: item.roomNo,
      Category: item.category,
      AC: item.ac,
      BookingBy: item.bookingBy,
      Stay: item.stay,
      Arrival: item.arrival,
      PlaceOfIssue: item.placeOfIssue,
      Visa: item.visa,
      IssueVisa: item.issueVisa,
      Expiry: item.expiry,
      Issue: item.issue,
      SingleRate: item.singleRate ? "Yes" : "No",
      WithBreakfast: item.withBreakfast ? "Yes" : "No",
      WithLunchDinner: item.withLunchDinner ? "Yes" : "No",
      WithBreakfastLunchDinner: item.withBreakfastLunchDinner ? "Yes" : "No",
      RoomOnly: item.roomOnly ? "Yes" : "No",
      ExtraPerson: item.extraPerson ? "Yes" : "No",

      // Images URLs
      ImageUrl: item.imageUrl,
      AdharUrl: item.adharUrl,
      DrivingUrl: item.drivingUrl,
      PanUrl: item.panUrl,
      VoterUrl: item.voterUrl,
      GovernmentUrl: item.govermentUrl,

      // File Names (if you want file name separately)
      AdharImage: item.adharImage,
      DrivingLicenseImage: item.drivingLicense,
      PanNoImage: item.panNo,
      VoterIdImage: item.voterIdImage,
      GovernmentIssuedIdImage: item.goverMentIssuedIdImage,

      // Other Guests Info
      OtherGuests: item.other
        ?.map(
          (guest, index) =>
            `Guest ${index + 1}: ${guest.name} (${guest.relation}) - ${guest.select}: ${guest.adharNo}-${guest.otherAdharUrl}`,
        )
        .join("; "),
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "RoomData");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(fileData, "RoomData.xlsx");
  };

  // Apply all filters (search + date)
  useEffect(() => {
    let filtered = [...data];

    // Apply search filter
    if (searchTerm) {
      filtered = filtered.filter(
        (item) =>
          item.phoneNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.registration?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.name?.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    }

    // Apply date filters
    if (startDate) {
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);
      filtered = filtered.filter((item) => {
        if (!item.date) return false;
        const itemDate = new Date(item.date);
        return itemDate >= start;
      });
    }

    if (endDate) {
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      filtered = filtered.filter((item) => {
        if (!item.date) return false;
        const itemDate = new Date(item.date);
        return itemDate <= end;
      });
    }

    setFilteredData(filtered);
  }, [searchTerm, startDate, endDate, data]);

  // Initial data fetch
  useEffect(() => {
    fetchData();
  }, [customerId]);

  // Check if any filter is active
  const isFilterActive = searchTerm || startDate || endDate;

  return (
    <div>
      <UpdateRoomBookModal
        id={id}
        data={roomBook}
        registrationNo={registrationNo}
        isOpen={isEditOpen && !isForeignReport}
        onClose={onEditClose}
        onOpen={onEditOpen}
        customerId={customerId}
      />

      <ForeignReportModal
        id={id}
        data={roomBook}
        registrationNo={registrationNo}
        isOpen={isEditOpen && isForeignReport}
        onClose={onEditClose}
        onOpen={onEditOpen}
        isForeignReport={isForeignReport}
        setIsForeignReport={setIsForeignReport}
        customerId={customerId}
      />

      <RoomBookPrintModal
        isOpen={isPrintOpen}
        onOpen={onPrintOpen}
        onClose={onPrintClose}
        roomBookData={filteredData}
        customerId={customerId}
      />

      {/* Filters Section */}
      <Box mt={10} p={4} borderWidth="1px" borderRadius="lg" boxShadow="sm">
        <Flex direction="column" gap={4}>
          {/* Active Filters Indicator */}
          {isFilterActive && (
            <Flex
              align="center"
              justify="space-between"
              bg="blue.50"
              p={2}
              borderRadius="md"
            >
              <Flex align="center" gap={2}>
                <FaFilter color="#3182CE" />
                <Text fontSize="sm" color="blue.700">
                  Filters applied:
                  {searchTerm && ` Search: "${searchTerm}"`}
                  {startDate && ` From: ${startDate}`}
                  {endDate && ` To: ${endDate}`}
                </Text>
              </Flex>
              <IconButton
                size="sm"
                icon={<FaTimes />}
                colorScheme="blue"
                variant="ghost"
                onClick={clearAllFilters}
                aria-label="Clear all filters"
              />
            </Flex>
          )}

          <Flex gap={2} wrap="wrap" align="center">
            {/* Search Input */}
            <Input
              flex="1"
              minW="300px"
              type="text"
              placeholder="Search by Phone No, Registration, or Name"
              value={searchTerm}
              onChange={handleSearchChange}
            />

            {/* Date Filters */}
            <Flex gap={2} align="center">
              <Box position="relative">
                <Input
                  type="date"
                  value={startDate}
                  onChange={handleStartChange}
                  max={endDate}
                />
                {startDate && (
                  <Box
                    position="absolute"
                    top="-2px"
                    right="-2px"
                    bg="blue.500"
                    color="white"
                    fontSize="xs"
                    px={1}
                    borderRadius="full"
                  >
                    ✓
                  </Box>
                )}
              </Box>

              <Text>to</Text>

              <Box position="relative">
                <Input
                  type="date"
                  value={endDate}
                  onChange={handleEndChange}
                  min={startDate}
                />
                {endDate && (
                  <Box
                    position="absolute"
                    top="-2px"
                    right="-2px"
                    bg="blue.500"
                    color="white"
                    fontSize="xs"
                    px={1}
                    borderRadius="full"
                  >
                    ✓
                  </Box>
                )}
              </Box>

              {(startDate || endDate) && (
                <IconButton
                  icon={<FaTimes />}
                  size="sm"
                  onClick={clearDateFilter}
                  aria-label="Clear date filter"
                  variant="outline"
                />
              )}
            </Flex>

            {/* Action Buttons */}
            <Flex gap={2}>
              <Button
                colorScheme="teal"
                onClick={exportToExcel}
                leftIcon={<FaFilter />}
                isLoading={isLoading}
              >
                Export Excel
              </Button>
              <Button
                colorScheme="blue"
                onClick={handlePrintModal}
                isLoading={isLoading}
              >
                Print
              </Button>
              <Button
                onClick={fetchData}
                isLoading={isLoading}
                variant="outline"
              >
                Refresh
              </Button>
            </Flex>
          </Flex>

          {/* Results Count */}
          <Flex justify="space-between" align="center">
            <Text fontSize="sm" color="gray.600">
              Showing {filteredData.length} of {data.length} records
            </Text>
            {isFilterActive && (
              <Text fontSize="sm" color="blue.600">
                {searchTerm && `Searching for: "${searchTerm}"`}
                {startDate &&
                  ` From: ${new Date(startDate).toLocaleDateString()}`}
                {endDate && ` To: ${new Date(endDate).toLocaleDateString()}`}
              </Text>
            )}
          </Flex>
        </Flex>
      </Box>

      {/* Table Section */}
      <TableContainer mt={4} width="full" overflowX="auto">
        {isLoading ? (
          <Flex justify="center" align="center" h="200px">
            <Text>Loading data...</Text>
          </Flex>
        ) : filteredData.length === 0 ? (
          <Flex
            justify="center"
            align="center"
            h="200px"
            direction="column"
            gap={4}
          >
            <Text fontSize="lg" color="gray.500">
              {data.length === 0
                ? "No data available"
                : "No records match your filters"}
            </Text>
            {isFilterActive && (
              <Button
                colorScheme="blue"
                variant="outline"
                onClick={clearAllFilters}
              >
                Clear all filters
              </Button>
            )}
          </Flex>
        ) : (
          <Table size="sm" variant="striped" colorScheme="teal">
            <TableCaption>
              Room Book Data ({filteredData.length} records)
              {isFilterActive && " - Filtered View"}
            </TableCaption>
            <Thead bg="teal.500">
              <Tr>
                <Th color="white">Name</Th>
                <Th color="white">Registration</Th>
                <Th color="white">Nationality</Th>
                <Th color="white">Purpose</Th>
                <Th color="white">Date</Th>
                <Th color="white">Address</Th>
                <Th color="white">Customer Gst</Th>
                <Th color="white">Phone No</Th>
                <Th color="white">Arrived From</Th>
                <Th color="white">Next Destination</Th>
                <Th color="white">Aadhar</Th>
                <Th color="white">Image</Th>
                <Th color="white">Aadhar Image</Th>
                <Th color="white">Pan Image</Th>
                <Th color="white">Driving License Image</Th>
                <Th color="white">Voter Id</Th>
                <Th color="white">Voter Image</Th>
                <Th color="white">Government IssueId</Th>
                <Th color="white">Government IssueId Image</Th>
                <Th color="white">CheckIn</Th>
                <Th color="white">CheckOut</Th>
                <Th color="white">PAX</Th>
                <Th color="white">Adult</Th>
                <Th color="white">Child</Th>
                <Th color="white">Other</Th>
                <Th color="white">Room No</Th>
                <Th color="white">Category</Th>
                <Th color="white">Booking By</Th>
                <Th color="white">Single Rate</Th>
                <Th color="white">With Breakfast</Th>
                <Th color="white">With BreakfastLunchDinner</Th>
                <Th color="white">Extra Person</Th>
                <Th color="white">Ac</Th>
                <Th color="white">Passport No</Th>
                <Th color="white">Issue Date</Th>
                <Th color="white">Date of Arrival</Th>
                <Th color="white">Place of Issue</Th>
                <Th color="white">Duration of stay in India</Th>
                <Th color="white">Visa No</Th>
                <Th color="white">Issue Date of Visa</Th>
                <Th color="white">Expiry Date</Th>
                <Th color="white">Edit</Th>
                <Th color="white">Foreigner Report</Th>
                <Th color="white">Delete</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredData.map((item, index) => (
                <Tr key={index} _hover={{ bg: "gray.50" }}>
                  <Td>{item.name}</Td>
                  <Td fontWeight="medium">{item.registration}</Td>
                  <Td>{item.nationality}</Td>
                  <Td>{item.purpose}</Td>
                  <Td>
                    {item.date ? new Date(item.date).toLocaleDateString() : "-"}
                  </Td>
                  <Td maxW="150px" whiteSpace="pre-wrap">
                    {item.address}
                  </Td>
                  <Td>{item.gstNo || "-"}</Td>
                  <Td>{item.phoneNo}</Td>
                  <Td>{item.arrivedFrom}</Td>
                  <Td>{item.nextDestination}</Td>
                  <Td>{item.adhar}</Td>
                  <Td>
                    {item.imageUrl ? (
                      <Image
                        src={item.imageUrl}
                        width={80}
                        height={80}
                        objectFit="cover"
                        borderRadius="md"
                      />
                    ) : (
                      "-"
                    )}
                  </Td>
                  <Td>
                    {item.adharUrl ? (
                      <Image
                        src={item.adharUrl}
                        width={80}
                        height={80}
                        objectFit="cover"
                        borderRadius="md"
                      />
                    ) : (
                      "-"
                    )}
                  </Td>
                  <Td>
                    {item.panUrl ? (
                      <Image
                        src={item.panUrl}
                        width={80}
                        height={80}
                        objectFit="cover"
                        borderRadius="md"
                      />
                    ) : (
                      "-"
                    )}
                  </Td>
                  <Td>
                    {item.drivingUrl ? (
                      <Image
                        src={item.drivingUrl}
                        width={80}
                        height={80}
                        objectFit="cover"
                        borderRadius="md"
                      />
                    ) : (
                      "-"
                    )}
                  </Td>
                  <Td>{item.voterId}</Td>
                  <Td>
                    {item.voterUrl ? (
                      <Image
                        src={item.voterUrl}
                        width={80}
                        height={80}
                        objectFit="cover"
                        borderRadius="md"
                      />
                    ) : (
                      "-"
                    )}
                  </Td>
                  <Td>{item.goverMentIssuedId}</Td>
                  <Td>
                    {item.govermentUrl ? (
                      <Image
                        src={item.govermentUrl}
                        width={80}
                        height={80}
                        objectFit="cover"
                        borderRadius="md"
                      />
                    ) : (
                      "-"
                    )}
                  </Td>
                  <Td>{item.checkIn}</Td>
                  <Td>{item.checkOut}</Td>
                  <Td>{item.pax}</Td>
                  <Td>{item.adult}</Td>
                  <Td>{item.child}</Td>
                  <Td>
                    {item.other && item.other.length > 0 ? (
                      <Table size="xs" variant="simple">
                        <Thead>
                          <Tr>
                            <Td fontSize="xs" fontWeight="bold">
                              Name
                            </Td>
                            <Td fontSize="xs" fontWeight="bold">
                              Document
                            </Td>
                            <Td fontSize="xs" fontWeight="bold">
                              No
                            </Td>
                            <Td fontSize="xs" fontWeight="bold">
                              Image
                            </Td>
                            <Td fontSize="xs" fontWeight="bold">
                              Relation
                            </Td>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {item.other.map((other, idx) => (
                            <Tr key={idx}>
                              <Td fontSize="xs">{other.name}</Td>
                              <Td fontSize="xs">{other.select || "-"}</Td>
                              <Td fontSize="xs">{other.adharNo || "-"}</Td>
                              <Td>
                                {other.otherAdharUrl ? (
                                  <Image
                                    src={other.otherAdharUrl}
                                    width={60}
                                    height={60}
                                  />
                                ) : (
                                  "-"
                                )}
                              </Td>
                              <Td fontSize="xs">{other.relation}</Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    ) : (
                      "-"
                    )}
                  </Td>
                  <Td>{item.roomNo}</Td>
                  <Td>{item.category}</Td>
                  <Td>{item.bookingBy}</Td>
                  <Td>{item.singleRate ? "Yes" : "No"}</Td>
                  <Td>{item.withBreakfast ? "Yes" : "No"}</Td>
                  <Td>{item.withBreakfastLunchDinner ? "Yes" : "No"}</Td>
                  <Td>{item.extraPerson ? "Yes" : "No"}</Td>
                  <Td>{item.ac}</Td>
                  <Td>{item.passport || "-"}</Td>
                  <Td>{item.issue || "-"}</Td>
                  <Td>{item.arrival || "-"}</Td>
                  <Td>{item.placeOfIssue || "-"}</Td>
                  <Td>{item.stay || "-"}</Td>
                  <Td>{item.visa || "-"}</Td>
                  <Td>{item.issueVisa || "-"}</Td>
                  <Td>{item.expiry || "-"}</Td>
                  <Td>
                    <Button
                      size="sm"
                      colorScheme="green"
                      onClick={() => edit(item._id, item.registration)}
                      leftIcon={<FaEdit />}
                    >
                      Edit
                    </Button>
                  </Td>
                  <Td>
                    {item.nationality === "Others" ? (
                      <Button
                        size="sm"
                        colorScheme="blue"
                        onClick={() => edit(item._id, item.registration, true)}
                      >
                        Foreigner Report
                      </Button>
                    ) : (
                      <Text color="gray.500">NA</Text>
                    )}
                  </Td>
                  <Td>
                    <Button
                      size="sm"
                      colorScheme="red"
                      onClick={() => DeleteModal(item._id)}
                      leftIcon={<FaTrash />}
                    >
                      Delete
                    </Button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
      </TableContainer>

      {/* Delete Confirmation Dialog */}
      <AlertDialog
        isOpen={isOpen1}
        leastDestructiveRef={cancelRef}
        onClose={onClose1}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure you want to delete this record? This action cannot be
              undone.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose1}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </div>
  );
};

export default RoomBookData;
